export default "/assets/images/time-badge.d0a363e3d9acdb1c.svg";